import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse } from '@/data/models/ServiceResponse'
import { ILayout } from '@/data/models/Layout'

export class LayoutApiService extends ApiService {
  /**
   * Returns paginated list of Layouts
   */
  static async getLayouts(params: object): Promise<IPaginatedServiceResponse<ILayout>> {
    return this.axios.get('layouts', {
      params
    }).then((response: AxiosResponse<IPaginatedServiceResponse<ILayout>>) => response.data)
  }

  static async createLayout(layoutData: ILayout): Promise<IPaginatedServiceResponse<ILayout>> {
    return this.axios.post('layouts', layoutData)
      .then((response: AxiosResponse<IPaginatedServiceResponse<ILayout>>) => response.data)
  }

  static async updateLayout(data: ILayout): Promise<IPaginatedServiceResponse<ILayout>> {
    return this.axios.put(`layouts/${data.id}`, data)
      .then((response: AxiosResponse<IPaginatedServiceResponse<ILayout>>) => response.data)
  }

  static async deleteLayout(layoutId: number): Promise<IPaginatedServiceResponse<ILayout>> {
    return this.axios.delete(`layouts/${layoutId}`)
      .then((response: AxiosResponse<IPaginatedServiceResponse<ILayout>>) => response.data)
  }

  static async getVariants(params: { dashboard: string, name: string }): Promise<IPaginatedServiceResponse<ILayout>> {
    return this.axios.get('layouts/variants', { params })
      .then((response: AxiosResponse<IPaginatedServiceResponse<ILayout>>) => response.data)
  }

  static async updateOrder(data: object): Promise<IPaginatedServiceResponse<ILayout>> {
    return this.axios.post('layouts/reorder', {
      layouts: data
    }).then((response: AxiosResponse<IPaginatedServiceResponse<ILayout>>) => response.data)
  }

  static async saveVariables(layoutId: number, data: object): Promise<IPaginatedServiceResponse<ILayout>> {
    return this.axios.post(`layouts/${layoutId}/variables`, data)
      .then((response: AxiosResponse<IPaginatedServiceResponse<ILayout>>) => response.data)
  }
}
